import ih from 'immutability-helper';

import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_NOTIFICATIONS_LIST_REQUEST:
    case types.GET_NOTIFICATIONS_COUNT_REQUEST:
      return ih(state, {
        list: {
          $merge: {
            isLoading: true,
            error: '',
          },
        },
      });
    case types.GET_NOTIFICATIONS_LIST_SUCCESS:
      return ih(state, {
        list: {
          isLoading: { $set: false },
          data: {
            items: { $push: action.payload.notifications },
            count: { $set: action.payload.count },
          },
          paginationOptions: { $set: action.payload.paginationOptions },
        },
      });
    case types.GET_NOTIFICATIONS_LIST_ERROR:
    case types.GET_NOTIFICATIONS_COUNT_ERROR:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_NOTIFICATIONS_COUNT_SUCCESS:
      return ih(state, {
        list: {
          isLoading: { $set: false },
          data: {
            unreadCount: { $set: action.payload.count },
          },
        },
      });
    case types.MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS:
      return ih(state, {
        list: {
          isLoading: { $set: false },
          paginationOptions: {
            $set: {
              page: 1,
              size: 10,
              created_at__lt: '',
            },
          },
          data: {
            $set: {
              items: [],
              count: 0,
              unreadCount: action.payload.count,
            },
          },
        },
      });
    case types.REFRESH_NOTIFICATIONS_LIST_SUCCESS:
      return ih(state, {
        list: {
          isLoading: { $set: false },
          data: {
            items: { $set: action.payload.notifications },
            count: { $set: action.payload.count },
          },
          paginationOptions: { $set: action.payload.paginationOptions },
        },
      });
    default:
      return state;
  }
};
